export default __webpack_public_path__ + "static/tag-do-5-dark-65401e1c13450b922c928c0631a8ef810d2acd2f1690550fe6808c10b50bab38.png";